export const VIDEOS = {
    howItWorks: [
        'https://www.youtube.com/watch?v=example1',
        'https://www.youtube.com/watch?v=example2',
        'https://www.youtube.com/watch?v=example3',
    ],
    features: {
        mathematicalAccuracy: 'https://www.youtube.com/watch?v=example4',
        internalConsistency: 'https://www.youtube.com/watch?v=example5',
        nexlyAI: 'https://www.youtube.com/watch?v=example6',
    },
}
